
<div class="Nextclass">

  <div class="header">

    <div class="icon">

    <span class="material-symbols-outlined" style="font-size: 25px;">

      local_library

      </span>

    </div>

      <span id="headertext">What to learn next </span>

      <span id="viewtext" (click) = "navigatetoESD()" >View all >> </span>

  </div>

  <div class="content">

  <div class="imagecontents" *ngFor="let item of data">

    <img src="https://images.ctfassets.net/mrop88jh71hl/55rrbZfwMaURHZKAUc5oOW/9e5fe805eb03135b82e962e92169ce6d/python-programming-language.png?w=750&h=750&q=100&fm=png" alt="" srcset="">

    <div class="textcontent">

      <span id="text" >{{item.programName}}</span>

      <span id="subtext">{{item.programDescription}}</span>

    </div>

  </div>

  
</div>

</div>